module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "edit-user-box"
  }, [_c('form', {
    staticClass: "form-user",
    attrs: {
      "id": "formUser"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "col-md-6 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.name),
      expression: "usuario.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.usuario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.email),
      expression: "usuario.email"
    }],
    staticClass: "form-control email-input",
    attrs: {
      "id": "email",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.usuario.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row-2"
  }, [_c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.username),
      expression: "usuario.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "CPF",
      "maxlength": "11",
      "id": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.usuario.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row-3"
  }, [_c('div', {
    staticClass: "col-md-3 mb-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.roles),
      expression: "usuario.roles"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "multiple",
      "size": "5",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.usuario, "roles", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listaRoles), function(role) {
    return _c('option', {
      key: role.id,
      domProps: {
        "value": role
      }
    }, [_vm._v(_vm._s(role.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Skin")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.skin),
      expression: "usuario.skin"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": "multiple",
      "size": "5",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.usuario, "skin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listaSkin), function(skin) {
    return _c('option', {
      key: skin.id,
      domProps: {
        "value": skin
      }
    }, [_vm._v(_vm._s(skin.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mb-3"
  }, [_c('div', {
    staticClass: "form-check checkbox-agente"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.agent),
      expression: "usuario.agent"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "agent"
    },
    domProps: {
      "checked": Array.isArray(_vm.usuario.agent) ? _vm._i(_vm.usuario.agent, null) > -1 : (_vm.usuario.agent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.usuario.agent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.usuario, "agent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.usuario, "agent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.usuario, "agent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "agent"
    }
  }, [_vm._v("\n              Agente de Registro\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.copyBiometricsLocalToSpid()
      }
    }
  }, [_vm._v("Copiar biometria para base SPID\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row-4"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3",
    staticStyle: {
      "width": "17% !important"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftHand),
      expression: "leftHand"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "LeftHand"
    },
    domProps: {
      "checked": Array.isArray(_vm.leftHand) ? _vm._i(_vm.leftHand, null) > -1 : (_vm.leftHand)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('LeftHand')
      },
      "change": function($event) {
        var $$a = _vm.leftHand,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.leftHand = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.leftHand = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.leftHand = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "LeftHand"
    }
  }, [_vm._v("\n            Mão Esquerda\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftThumb),
      expression: "leftThumb"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "LeftThumb",
      "disabled": _vm.leftHand
    },
    domProps: {
      "checked": Array.isArray(_vm.leftThumb) ? _vm._i(_vm.leftThumb, null) > -1 : (_vm.leftThumb)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('LeftThumb')
      },
      "change": function($event) {
        var $$a = _vm.leftThumb,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.leftThumb = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.leftThumb = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.leftThumb = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "LeftThumb"
    }
  }, [_vm._v("\n            Polegar Esquerdo\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftIndexFinger),
      expression: "leftIndexFinger"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "LeftIndexFinger",
      "disabled": _vm.leftHand
    },
    domProps: {
      "checked": Array.isArray(_vm.leftIndexFinger) ? _vm._i(_vm.leftIndexFinger, null) > -1 : (_vm.leftIndexFinger)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('LeftIndexFinger')
      },
      "change": function($event) {
        var $$a = _vm.leftIndexFinger,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.leftIndexFinger = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.leftIndexFinger = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.leftIndexFinger = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "LeftIndexFinger"
    }
  }, [_vm._v("\n            Indicador Esquerdo\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftMiddleFinger),
      expression: "leftMiddleFinger"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "LeftMiddleFinger",
      "disabled": _vm.leftHand
    },
    domProps: {
      "checked": Array.isArray(_vm.leftMiddleFinger) ? _vm._i(_vm.leftMiddleFinger, null) > -1 : (_vm.leftMiddleFinger)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('LeftMiddleFinger')
      },
      "change": function($event) {
        var $$a = _vm.leftMiddleFinger,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.leftMiddleFinger = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.leftMiddleFinger = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.leftMiddleFinger = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "LeftMiddleFinger"
    }
  }, [_vm._v("\n            Médio Esquerdo\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftRingFinger),
      expression: "leftRingFinger"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "LeftRingFinger",
      "disabled": _vm.leftHand
    },
    domProps: {
      "checked": Array.isArray(_vm.leftRingFinger) ? _vm._i(_vm.leftRingFinger, null) > -1 : (_vm.leftRingFinger)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('LeftRingFinger')
      },
      "change": function($event) {
        var $$a = _vm.leftRingFinger,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.leftRingFinger = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.leftRingFinger = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.leftRingFinger = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "LeftRingFinger"
    }
  }, [_vm._v("\n            Anelar Esquerdo\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftLittleFinger),
      expression: "leftLittleFinger"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "LeftLittleFinger",
      "disabled": _vm.leftHand
    },
    domProps: {
      "checked": Array.isArray(_vm.leftLittleFinger) ? _vm._i(_vm.leftLittleFinger, null) > -1 : (_vm.leftLittleFinger)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('LeftLittleFinger')
      },
      "change": function($event) {
        var $$a = _vm.leftLittleFinger,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.leftLittleFinger = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.leftLittleFinger = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.leftLittleFinger = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "LeftLittleFinger"
    }
  }, [_vm._v("\n            Mínimo Esquerdo\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftHandReason),
      expression: "leftHandReason"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "id": "sel_LeftHand",
      "disabled": !this.leftHand
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leftHandReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftThumbReason),
      expression: "leftThumbReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_LeftThumb",
      "disabled": !this.leftThumb
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leftThumbReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftIndexFingerReason),
      expression: "leftIndexFingerReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_LeftIndexFinger",
      "disabled": !this.leftIndexFinger
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leftIndexFingerReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftMiddleFingerReason),
      expression: "leftMiddleFingerReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_LeftMiddleFinger",
      "disabled": !this.leftMiddleFinger
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leftMiddleFingerReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftRingFingerReason),
      expression: "leftRingFingerReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_LeftRingFinger",
      "disabled": !this.leftRingFinger
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leftRingFingerReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftLittleFingerReason),
      expression: "leftLittleFingerReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_LeftLittleFinger",
      "disabled": !this.leftLittleFinger
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leftLittleFingerReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3",
    staticStyle: {
      "width": "17% !important"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightHand),
      expression: "rightHand"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "RightHand"
    },
    domProps: {
      "checked": Array.isArray(_vm.rightHand) ? _vm._i(_vm.rightHand, null) > -1 : (_vm.rightHand)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('RightHand')
      },
      "change": function($event) {
        var $$a = _vm.rightHand,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rightHand = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rightHand = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rightHand = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "RightHand"
    }
  }, [_vm._v("\n            Mão Direita\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightThumb),
      expression: "rightThumb"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "RightThumb",
      "disabled": _vm.rightHand
    },
    domProps: {
      "checked": Array.isArray(_vm.rightThumb) ? _vm._i(_vm.rightThumb, null) > -1 : (_vm.rightThumb)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('RightThumb')
      },
      "change": function($event) {
        var $$a = _vm.rightThumb,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rightThumb = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rightThumb = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rightThumb = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "RightThumb"
    }
  }, [_vm._v("\n            Polegar Direito\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightIndexFinger),
      expression: "rightIndexFinger"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "RightIndexFinger",
      "disabled": _vm.rightHand
    },
    domProps: {
      "checked": Array.isArray(_vm.rightIndexFinger) ? _vm._i(_vm.rightIndexFinger, null) > -1 : (_vm.rightIndexFinger)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('RightIndexFinger')
      },
      "change": function($event) {
        var $$a = _vm.rightIndexFinger,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rightIndexFinger = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rightIndexFinger = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rightIndexFinger = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "RightIndexFinger"
    }
  }, [_vm._v("\n            Indicador Direito\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightMiddleFinger),
      expression: "rightMiddleFinger"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "RightMiddleFinger",
      "disabled": _vm.rightHand
    },
    domProps: {
      "checked": Array.isArray(_vm.rightMiddleFinger) ? _vm._i(_vm.rightMiddleFinger, null) > -1 : (_vm.rightMiddleFinger)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('RightMiddleFinger')
      },
      "change": function($event) {
        var $$a = _vm.rightMiddleFinger,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rightMiddleFinger = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rightMiddleFinger = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rightMiddleFinger = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "RightMiddleFinger"
    }
  }, [_vm._v("\n            Médio Direito\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightRingFinger),
      expression: "rightRingFinger"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "RightRingFinger",
      "disabled": _vm.rightHand
    },
    domProps: {
      "checked": Array.isArray(_vm.rightRingFinger) ? _vm._i(_vm.rightRingFinger, null) > -1 : (_vm.rightRingFinger)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('RightRingFinger')
      },
      "change": function($event) {
        var $$a = _vm.rightRingFinger,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rightRingFinger = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rightRingFinger = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rightRingFinger = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "RightRingFinger"
    }
  }, [_vm._v("\n            Anelar Direito\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightLittleFinger),
      expression: "rightLittleFinger"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "RightLittleFinger",
      "disabled": _vm.rightHand
    },
    domProps: {
      "checked": Array.isArray(_vm.rightLittleFinger) ? _vm._i(_vm.rightLittleFinger, null) > -1 : (_vm.rightLittleFinger)
    },
    on: {
      "click": function($event) {
        return _vm.checkControll('RightLittleFinger')
      },
      "change": function($event) {
        var $$a = _vm.rightLittleFinger,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rightLittleFinger = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rightLittleFinger = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rightLittleFinger = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "RightLittleFinger"
    }
  }, [_vm._v("\n            Mínimo Direito\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightHandReason),
      expression: "rightHandReason"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "id": "sel_RightHand",
      "disabled": !this.rightHand
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rightHandReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightThumbReason),
      expression: "rightThumbReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_RightThumb",
      "disabled": !this.rightThumb
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rightThumbReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightIndexFingerReason),
      expression: "rightIndexFingerReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_RightIndexFinger",
      "disabled": !this.rightIndexFinger
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rightIndexFingerReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightMiddleFingerReason),
      expression: "rightMiddleFingerReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_RightMiddleFinger",
      "disabled": !this.rightMiddleFinger
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rightMiddleFingerReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightRingFingerReason),
      expression: "rightRingFingerReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_RightRingFinger",
      "disabled": !this.rightRingFinger
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rightRingFingerReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightLittleFingerReason),
      expression: "rightLittleFingerReason"
    }],
    staticStyle: {
      "width": "80%",
      "margin-top": "5px"
    },
    attrs: {
      "id": "sel_RightLittleFinger",
      "disabled": !this.rightLittleFinger
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rightLittleFingerReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listReasons), function(reason) {
    return _c('option', {
      key: reason.id,
      domProps: {
        "value": reason.id
      }
    }, [_vm._v(_vm._s(reason.reason) + "\n            ")])
  }), 0), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.check('SAVE')) ? _c('div', {
    staticClass: "col-md-1 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.saveUser($event)
      }
    }
  }, [_vm._v("Salvar")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('ExternalAgentModal', {
    attrs: {
      "id": "externalAgentModal",
      "cpf": _vm.usuario.username
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon email-icon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-10 mb-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Exceções Biométricas:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8c1b95e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/EditUser.vue
// module id = 268
// module chunks = 0